import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Always start at the top on route changes, and disable the browser's
 * scroll restoration that can land users mid-page / on the footer.
 */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    // Allow in-page hash anchors (e.g. /help#organizers) to scroll themselves
    if (hash) return;

    const reset = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    reset();
    // Beat late browser scroll restoration / layout shifts after async content
    const raf = requestAnimationFrame(reset);
    const t0 = setTimeout(reset, 0);
    const t1 = setTimeout(reset, 50);
    const t2 = setTimeout(reset, 200);

    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t0);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
